import { request } from '@/utils/request';

const baseApiUrl: string | undefined = import.meta.env.VITE_GLOB_API_URL;

// sendBeacon本质上还是http post，但它可以防止中断，开销也会小一点
export function report(data: any) {
  return request({
    url: '/loki/report',
    method: 'post',
    data,
    cancelError: true,
  });
  // let params;

  // try {
  //   params = JSON.stringify(data || {});
  // } catch (e) {
  //   params = data;
  //   console.log('🚀 ~ report ~ params:', data);
  //   console.log('🚀 ~ report ~ error:', e);
  // }

  // navigator.sendBeacon(baseApiUrl + 'loki/report', params);
}
